import { selectedCustomer } from '@app/ngrx-customer/store';
import { createSelector } from '@ngrx/store';
import { productDetailsViewModelSelector } from '@product-detail/selectors/product-detail.selector';
import { ProductFilter } from '@shared/helpers/product-filter.helpers';

export const coveoTopSellersViewModelSelector = (productNumbers: number[]) =>
  createSelector(
    productDetailsViewModelSelector(productNumbers),
    selectedCustomer,
    (productDetails, selectedCustomer) => {
      return Array.from(productDetails?.values() ?? []).filter(
        product =>
          !!product &&
          ProductFilter.productPassesOgRestrictions(product, selectedCustomer),
      );
    },
  );
